import { useActivity } from "PFCore/hooks/queries/activity";

import { useActivityShowContext } from "../context/activity_show_context";

export const useCurrentActivity = () => {
  const { activityId } = useActivityShowContext();
  const { data: activity } = useActivity(activityId, { enabled: !!activityId });

  return activity!;
};
